/**
 * Created by Victor Rojo on 20/10/17.
 */
import { Component, OnInit}  from '@angular/core';
import { FormGroup, FormControl,
         FormBuilder, Validators }  from '@angular/forms';
import { ActivatedRoute, ParamMap,
         Router }                   from '@angular/router';
import { NotificationsService }     from 'angular2-notifications';

import {switchMap} from 'rxjs/operators';

import { CloudUserService } from "../profile/cloudUser.service";
import { CloudUser }        from "../model/cloudUser";
import { I18NService }      from "../shared/i18n/i18n.service";

@Component({
  templateUrl: './cloudUser-detail.component.html',
  styleUrls: [ './cloudUser-detail.component.css'],
})
export class CloudUserDetailComponent implements OnInit{

  detailForm: FormGroup;
  isBusy = false;
  isLoading = true;
  cloudUser: CloudUser;

  constructor(private fb: FormBuilder,
              private cloudUserService: CloudUserService,
              private router: Router,
              private route: ActivatedRoute,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {
    let pattern = /^[A-Za-z0-9\S\*]*$/;
    this.detailForm = fb.group({
      'userName' : [null, Validators.required],
      'login' : [null, Validators.compose([Validators.required, Validators.pattern(pattern)])],
      'emailAddress' : [null, Validators.compose([Validators.required, Validators.email])],
      'admin': [null],
      'cloudNotifications': [null],
      'sendViaEmail': [true]
    });
  }


  ngOnInit():void {
    let pattern = /^[A-Za-z0-9\S\*]*$/;
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        let id = params.get('id');
        if ( !id ) {
          this.isLoading = false;
          this.detailForm.controls['admin'].setValue(false);

          this.detailForm.get('sendViaEmail').valueChanges.subscribe(val => {
            if ( val ) {
              this.detailForm.removeControl("password");
            } else {
              this.detailForm.addControl('password', this.fb.control(null, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(pattern)]) ) );
            }
          });
          return [];
        }
        return this.cloudUserService.get(id)
      }))
      .subscribe( cloudUser => {
        this.isLoading = false;
        if ( cloudUser ){
          this.cloudUser = cloudUser;
          this.detailForm.controls['userName'].setValue(this.cloudUser.userName);
          this.detailForm.controls['login'].setValue(this.cloudUser.login);
          this.detailForm.controls['emailAddress'].setValue(this.cloudUser.emailAddress);
          this.detailForm.controls['admin'].setValue(this.cloudUser.admin);
          this.detailForm.controls['cloudNotifications'].setValue(this.cloudUser.cloudNotifications);
        }
      });
  }

  onBlurChecker(fieldName: string):void{
    let filter = fieldName + ":" + this.detailForm.controls[fieldName].value;
    if ( !this.cloudUser || this.detailForm.controls[fieldName].value != this.cloudUser[fieldName]) {
      this.cloudUserService.check(filter)
        .then( res => {
          if ( res ) {
            this.detailForm.controls[fieldName].setErrors( { used: true})
          }
        })
    }
  }

  saveUser():void {
    let changes = {};
    let changed = false;

    let fields = ['userName','login','emailAddress', 'admin', 'cloudNotifications'];
    fields.forEach( field => {
      if ( this.detailForm.controls[field].dirty ){
        changes[field] = this.detailForm.controls[field].value;
        changed = true;
      }
    });
    if ( changed && this.detailForm.valid ) {
      this.isBusy = true;
      this.cloudUserService.patch(this.cloudUser.idCloudUser, changes)
        .then( res => {
          this.isBusy = false;
          fields.forEach(field => {
            this.cloudUser[field] = changes[field];
            if (this.detailForm.controls[field].value == changes[field]) {
              this.detailForm.controls[field].markAsPristine();
            }
          });
          this.notificationService.success(
            this.i18nService.get("success"),
            this.i18nService.get("dataSaved")
          );
        })
        .catch( error => {
          this.isBusy = false;
          this.notificationService.error(
            this.i18nService.get("error") ,
            this.i18nService.get("cantSaveData")
          );
        })
    }
  }

  createUser(): void {
    let data = {};

    let fields = ['userName','login','emailAddress', 'admin', 'cloudNotifications'];
    if ( !this.detailForm.controls['sendViaEmail'].value ) {
      fields.push("password");
    }
    fields.forEach( field => {
      if ( this.detailForm.controls[field].dirty ){
        data[field] = this.detailForm.controls[field].value;
      }
    });
    if ( this.detailForm.valid ) {
      this.isBusy = true;
      this.cloudUserService.create(data)
        .then( cloudUser => {
          this.isBusy = false;
          this.cloudUser = cloudUser;
          fields.forEach(field => {
            if (this.detailForm.controls[field].value == cloudUser[field]) {
              this.detailForm.controls[field].markAsPristine();
            }
          });
          this.router.navigate(['users']);
          this.notificationService.success(
            this.i18nService.get("success"),
            this.i18nService.get("newUserCreated")
          );
        })
        .catch( error => {
          this.isBusy = false;
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("cantCreateUser")
          );
        })
    }
  }
}
